var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCustomerLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66806",
    "data-name": "Group 66806",
    transform: "translate(7927 -8142)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4123",
    "data-name": "Ellipse 4123",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(-7927 8142)",
    fill: "#ffe5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "log-in-04",
    d: "M13.821,9.214l4.81,4.81m0,0-4.81,4.81m4.81-4.81H3m.406-6.012a12.024,12.024,0,1,1,0,12.024",
    transform: "translate(-7921.5 8147.5)",
    fill: "none",
    stroke: "#fd0e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerLogin);
export default __webpack_public_path__ + "static/media/IconCustomerLogin.ffc904a3.svg";
export { ForwardRef as ReactComponent };